"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStorageManager = exports.SessionStorageType = void 0;
var SessionStorageType;
(function (SessionStorageType) {
    /**
     * Save and restore selection Context for views
     */
    SessionStorageType[SessionStorageType["SelectionContext_Restore"] = 0] = "SelectionContext_Restore";
    /**
     * WorkflowManager clipboard
     */
    SessionStorageType[SessionStorageType["WF_Clipboard"] = 1] = "WF_Clipboard";
})(SessionStorageType = exports.SessionStorageType || (exports.SessionStorageType = {}));
class SessionStorageManager {
    static getItem(sessionStorageType, key) {
        let itemKey = this.getItemKey(sessionStorageType, key);
        let item = window.sessionStorage.getItem(itemKey);
        if (item)
            return JSON.parse(item);
        return undefined;
    }
    static setItem(sessionStorageType, key, value) {
        window.sessionStorage.setItem(this.getItemKey(sessionStorageType, key), JSON.stringify(value));
    }
    static trySetItem(sessionStorageType, key, value) {
        try {
            SessionStorageManager.setItem(sessionStorageType, key, value);
            return true;
        }
        catch (e) {
            return false;
        }
    }
    static removeItem(sessionStorageType, key) {
        let itemKey = this.getItemKey(sessionStorageType, key);
        window.sessionStorage.removeItem(itemKey);
    }
    static removeSessionStorageType(sessionStorageType, key) {
        let arr = [];
        let prefix = "";
        if (sessionStorageType === SessionStorageType.SelectionContext_Restore)
            prefix = "SSM__LastSelection_" + key;
        // Iterate over localStorage and insert the keys that meet the condition into arr
        for (let i = 0; i < window.sessionStorage.length; i++) {
            if (window.sessionStorage.key(i).substring(0, prefix.length) === prefix)
                arr.push(window.sessionStorage.key(i));
        }
        for (let i = 0; i < arr.length; i++)
            window.sessionStorage.removeItem(arr[i]);
    }
    static getItemKey(sessionStorageType, externalKey) {
        return "SSM_" + "_" + SessionStorageType[sessionStorageType] + "_" + externalKey;
    }
}
exports.SessionStorageManager = SessionStorageManager;
